@if(assignments) {
<div>
    @if(needsWorkApprovalCount === 1) {
        <div class="needs-approval-alert" [ngClass]="panelClass">
            <mat-icon class="needs-approval-alert__icon">warning</mat-icon>
            <span class="needs-approval-alert__text">
                <span class="needs-approval-alert__text bold">Needs Work Approval - </span>
                {{ pinnedNwaAssignment.cancellationReason }}
            </span>
        </div>
    }

    @if(needsWorkApprovalCount > 1) {
        <div class="needs-approval-alert" [ngClass]="panelClass">
            <mat-icon class="needs-approval-alert__icon">warning</mat-icon>
            <span class="needs-approval-alert__text">
                {{ needsWorkApprovalCount }} Work Approval Statuses
            </span>
        </div>
    }
</div>
} 